import React from 'react'
import { cn } from '~/lib/common-utils'
import Container from '~/components/ui/container'
import { TitleSection } from './title-section'

type SectionProps = {
  children: React.ReactNode
  className?: string
  title?: string
  subtitle?: string
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '7xl' | 'default' | 'full' | 'none'
  backgroundColor?: string
  id?: string
  as?: React.ElementType
  isIncludeContainer?: boolean
}

export default function Section({
  children,
  className,
  title,
  subtitle,
  maxWidth = 'default',
  backgroundColor = 'bg-white',
  id,
  as: SectionTag = 'section',
  isIncludeContainer = true,
}: SectionProps) {
  return (
    <SectionTag id={id} className={cn(backgroundColor, className)}>
      {isIncludeContainer ? (
        <Container
          maxWidth={maxWidth === 'none' ? 'full' : maxWidth}
          paddingY={'lg'}
          paddingX={'lg'}
          className={cn('relative')}
        >
          <TitleSection title={title} subtitle={subtitle} className="mb-6" />
          {children}
        </Container>
      ) : (
        children
      )}
    </SectionTag>
  )
}
